import React from "react";
import { Global } from "../Global";

const Banner = ({data}) => {
  return (
    <img src={Global.PHOTO_URL + data} alt="banner" className="banner " />
  )
}

export default Banner